// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import './ConfirmDialog.css';

export default function ConfirmDialog({ isOpen, onClose, onConfirm, message, title = "Confirm Deletion" }) {
    if (!isOpen) return null;

    return (
        <div className="confirm-dialog-overlay fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 animate-[fadeIn_0.2s_ease-in-out]" onClick={onClose}>
            <div className="confirm-dialog-container w-[90%] max-w-[400px] rounded-[8px] bg-white shadow-[0_10px_25px_rgba(0,0,0,0.2)] animate-[slideUp_0.2s_ease-out]" onClick={(e) => e.stopPropagation()}>
                <div className="confirm-dialog-header border-b border-[#e5e7eb] px-[24px] pt-[20px] pb-[16px]">
                    <h3 className="confirm-dialog-title m-0 text-[18px] font-[600] text-[#111827]">{title}</h3>
                </div>
                <div className="confirm-dialog-body px-[24px] py-[20px]">
                    <p className="confirm-dialog-message m-0 text-[14px] leading-[1.5] text-[#374151]">{message}</p>
                </div>
                <div className="confirm-dialog-footer flex justify-end gap-[12px] border-t border-[#e5e7eb] px-[24px] pt-[16px] pb-[20px]">
                    <button
                        type="button"
                        className="confirm-dialog-button confirm-dialog-button-cancel min-w-[80px] rounded-[6px] border-none bg-[#f3f4f6] px-[16px] py-[8px] text-[14px] font-[500] text-[#374151] transition-all duration-200 hover:bg-[#e5e7eb] active:scale-[0.98]"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="confirm-dialog-button confirm-dialog-button-confirm min-w-[80px] rounded-[6px] border-none bg-[#dc2626] px-[16px] py-[8px] text-[14px] font-[500] text-white transition-all duration-200 hover:bg-[#b91c1c] active:scale-[0.98]"
                        onClick={onConfirm}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

